import { ReactElement } from 'react';
import { useMapEvents } from 'react-leaflet';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { navigateAction } from '../../router/actions';

export default function SxkMapContainer({ children }): ReactElement {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  useMapEvents({
    moveend: (e) => {
      const currentCenter = e.target.getCenter();
      const currentZoom = e.target.getZoom();
      const path = `/sjokort/${currentCenter.lat},${currentCenter.lng},${currentZoom}`;
      dispatch(navigateAction(path));
      navigate(path);
    },
  });
  return children;
}
